import axios from 'axios';

/**
 * Pulls a human-readable message out of a failed save request, for endpoints whose
 * controller renders validation failures as `{ errors: string[] }` with a 4xx status
 * (e.g. ["Adder column limit of 5 reached"]) — axios rejects rather than resolving in
 * that case, so there's no body to inspect without this. This is a per-endpoint
 * response contract, not a universal Rails convention — controllers/serializers vary
 * (e.g. nested `{ errors: { field: [...] } }` shapes exist elsewhere in the app), so
 * confirm the target endpoint actually renders this shape before reusing this helper.
 * Falls back to the given generic message when there's nothing usable. Multiple messages are joined with
 * `separator` (", " by default); pass " " when the endpoint's messages are full sentences.
 */
export const getSaveErrorMessage = (error: unknown, fallback: string, separator = ', '): string => {
  if (axios.isAxiosError(error)) {
    const errors = (error.response?.data as { errors?: unknown } | undefined)?.errors;

    if (Array.isArray(errors) && errors.length) {
      const messages = errors.filter((message): message is string => typeof message === 'string');

      // Matches the sibling header_errors join in CustomColumnDrawerFooter.tsx for consistency.
      if (messages.length) return messages.join(separator);
    }
  }
  return fallback;
};
